import { graphql, type DocumentType } from '@/gql';

export const ASSIGNMENT_COURSE_TITLE_FRAGMENT = graphql(`
  fragment assignmentCourseTitleFields on Assignment {
    _id
    task {
      trainingCourse {
        title
        trainingCourse {
          _id
          title
        }
      }
    }
  }
`);

export type AssignmentCourseTitleAssignment = DocumentType<
  typeof ASSIGNMENT_COURSE_TITLE_FRAGMENT
>;

export function getAssignmentCourseTitle(
  assignment: AssignmentCourseTitleAssignment | null | undefined,
  fallback = 'Unknown course',
): string {
  const { trainingCourse } = assignment?.task ?? {};

  const { title: assignmentTitle } = trainingCourse ?? {};

  const { title: trainingCourseTitle } = trainingCourse?.trainingCourse ?? {};

  return assignmentTitle ?? trainingCourseTitle ?? fallback;
}
